import { SavePoint } from '@modules/save-points/types/save-point';
import { useFindPreviewById } from '@modules/test-development/services/preview.service';
import React from 'react';
import { useParams } from 'react-router-dom';

export const PreivewContext = React.createContext<{
  savePoint: SavePoint | null;
  isFetching: boolean;
}>({ savePoint: null, isFetching: false });

interface Props {
  children: React.ReactNode;
}

const PreivewContextProvider: React.FC<Props> = ({ children }) => {
  const { savePointId } = useParams();
  const { data, isFetching } = useFindPreviewById({
    savePointId,
    enabled: !!savePointId,
    queryKey: `find-preview-by-id-${savePointId}`,
  });

  return (
    <PreivewContext.Provider value={{ savePoint: data, isFetching }}>
      {children}
    </PreivewContext.Provider>
  );
};
export default PreivewContextProvider;
